/**
 * Airbridge 환경별 설정
 *
 * main app의 `apps/main/src/constants/env.ts` 패턴과 동일하게
 * TARGET_ENV를 5개 Mode(local/dev/test/stage/production)로 매핑하여
 * 환경별 Airbridge 토큰/앱명을 결정한다.
 */

enum AirbridgeMode {
  LOCAL = 'local',
  DEVELOPMENT = 'dev',
  TEST = 'test',
  STAGE = 'stage',
  PRODUCTION = 'production',
}

enum AirbridgeConfigKey {
  AIRBRIDGE_WEB_TOKEN = 'AIRBRIDGE_WEB_TOKEN',
  AIRBRIDGE_APP_NAME = 'AIRBRIDGE_APP_NAME',
}

const targetEnv = (process.env.NEXT_PUBLIC_TARGET_ENV || 'dev')
  .replace('mrtdev', 'dev')
  .replace('mrttest', 'test');

const env: AirbridgeMode = (() => {
  switch (true) {
    case targetEnv.includes('dev'):
      return AirbridgeMode.DEVELOPMENT;
    case targetEnv.includes('test'):
      return AirbridgeMode.TEST;
    default:
      return targetEnv as AirbridgeMode;
  }
})();

const DEV_AIRBRIDGE_WEB_TOKEN = 'a5e660987cb24f18ab456c1a27a17ff3';
const TEST_AIRBRIDGE_WEB_TOKEN = 'a5e660987cb24f18ab456c1a27a17ff3';
const PROD_AIRBRIDGE_WEB_TOKEN = '69626cbd65b94aae83f4e89bd988d2f7';

const DEV_AIRBRIDGE_APP_NAME = 'myrealtripdev';
const TEST_AIRBRIDGE_APP_NAME = 'myrealtripdev';
const PROD_AIRBRIDGE_APP_NAME = 'myrealtrip';

type AirbridgeConfig = Record<AirbridgeMode, Record<AirbridgeConfigKey, string>>;

const airbridgeConfigPreset: AirbridgeConfig = {
  [AirbridgeMode.LOCAL]: {
    AIRBRIDGE_WEB_TOKEN: DEV_AIRBRIDGE_WEB_TOKEN,
    AIRBRIDGE_APP_NAME: DEV_AIRBRIDGE_APP_NAME,
  },
  [AirbridgeMode.DEVELOPMENT]: {
    AIRBRIDGE_WEB_TOKEN: DEV_AIRBRIDGE_WEB_TOKEN,
    AIRBRIDGE_APP_NAME: DEV_AIRBRIDGE_APP_NAME,
  },
  [AirbridgeMode.TEST]: {
    AIRBRIDGE_WEB_TOKEN: TEST_AIRBRIDGE_WEB_TOKEN,
    AIRBRIDGE_APP_NAME: TEST_AIRBRIDGE_APP_NAME,
  },
  [AirbridgeMode.STAGE]: {
    AIRBRIDGE_WEB_TOKEN: PROD_AIRBRIDGE_WEB_TOKEN,
    AIRBRIDGE_APP_NAME: PROD_AIRBRIDGE_APP_NAME,
  },
  [AirbridgeMode.PRODUCTION]: {
    AIRBRIDGE_WEB_TOKEN: PROD_AIRBRIDGE_WEB_TOKEN,
    AIRBRIDGE_APP_NAME: PROD_AIRBRIDGE_APP_NAME,
  },
};

export const AIRBRIDGE_WEB_TOKEN = airbridgeConfigPreset[env].AIRBRIDGE_WEB_TOKEN;
export const AIRBRIDGE_APP_NAME = airbridgeConfigPreset[env].AIRBRIDGE_APP_NAME;
